import React from 'react';
import { useBiSessionContext } from '@components/Contexts/BiSessionContext';
import Header from '@components/Header';
import CommunityNavSubHeader from '@components/CommunityNavSubHeader';
import { useStudioCommunityHeader } from '@components/Hooks/ExperimentHooks/useStudioCommunityHeader';

interface Props {
  isMobile?: boolean;
}

const TemplatePageHeader = ({ isMobile }: Props) => {
  const { sessionId } = useBiSessionContext();
  const { isStudioCommunityHeaderEnabled } = useStudioCommunityHeader();

  if (isStudioCommunityHeaderEnabled) {
    return <CommunityNavSubHeader isMobile={isMobile} />;
  }

  return (
    <Header onClick={() => {}} pageName="template page" sessionId={sessionId} />
  );
};

export default TemplatePageHeader;
